/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMapPin = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M17 8A5 5 0 1 1 7 8a5 5 0 0 1 10 0" /><path fill="currentColor" d="M11.5 12h1v7.469c0 1.5-.5 1.562-.5 1.562s-.5-.062-.5-1.562z" /></svg>;
export default SvgMapPin;